<template>
  <v-container>
    <v-row>
      <Tabs
        :tabs="tabs"
        :level="2"
        :tab-lv1-index="tabLv1Index"
        :tabs-lv1-count="tabsLv1Count"
      />
    </v-row>
  </v-container>
</template>

<script>
import Tabs from '../../../components/Reporting/Tabs';
import ChairUtilization from './ChairUtilization';
import Collections from './Collections';
import Patients from './Patients';
import Production from './Production';

export default {
  name: 'RDHReporting',
  components: {
    Tabs,
    Collections,
    Patients,
    Production,
  },
  props: ['tabLv1Index', 'tabsLv1Count'],
  data() {
    return {
      pageName: 'RDH Reports',
      tabs: [
        { label: 'Collections', section: Collections },
        { label: 'Production', section: Production },
        { label: 'Patients', section: Patients },
        { label: 'Chair Utilization', section: ChairUtilization },
      ],
    };
  },
};
</script>
